import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import CountUp from 'react-countup';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';

const AdminDashboard = () => {
  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Admin Dashboard</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Dashboard Content */}
          <div className="row">
            {/* Welcome Card */}
            <div className="col-12">
              <div className="card bg-dark">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Welcome back, Admin!</h3>
                      <p>Manage your school efficiently</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-user-shield text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Users Count Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-primary-transparent me-2">
                      <i className="ti ti-users fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={4127} />
                        </h2>
                        <span className="badge bg-success">+2.1%</span>
                      </div>
                      <p>Total Users</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Teachers: <span className="text-dark fw-semibold">284</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Students: <span className="text-dark fw-semibold">3654</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Parents: <span className="text-dark fw-semibold">189</span>
                    </p>
                  </div>
                  <Link 
                    to={routes.userManagement} 
                    className="btn btn-primary btn-sm mt-2 w-100"
                  >
                    Manage Users
                  </Link>
                </div>
              </div>
            </div>

            {/* Pending Document Requests Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning-transparent me-2">
                      <i className="ti ti-file-text fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-warning">
                          <CountUp end={23} />
                        </h2>
                        <span className="badge bg-warning">Pending</span>
                      </div>
                      <p>Document Requests</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Approved: <span className="text-success fw-semibold">156</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Rejected: <span className="text-danger fw-semibold">12</span>
                    </p>
                  </div>
                  <Link 
                    to={routes.documentRequestsManagement} 
                    className="btn btn-warning btn-sm mt-2 w-100"
                  >
                    Review Requests
                  </Link>
                </div>
              </div>
            </div>

            {/* Today's Schedule Overview Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-calendar-event fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          <CountUp end={42} />
                        </h2>
                        <span className="badge bg-info">Today</span>
                      </div>
                      <p>Scheduled Classes</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Ongoing: <span className="text-success fw-semibold">8</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Upcoming: <span className="text-info fw-semibold">34</span>
                    </p>
                  </div>
                  <Link 
                    to={routes.schoolSchedule} 
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    View Schedule
                  </Link>
                </div>
              </div>
            </div>

            {/* System Alerts Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-danger-transparent me-2">
                      <i className="ti ti-alert-triangle fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-danger">
                          <CountUp end={5} />
                        </h2>
                        <span className="badge bg-danger">Alerts</span>
                      </div>
                      <p>System Alerts</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Critical: <span className="text-danger fw-semibold">2</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Warning: <span className="text-warning fw-semibold">3</span>
                    </p>
                  </div>
                  <Link 
                    to={routes.adminNotifications} 
                    className="btn btn-danger btn-sm mt-2 w-100"
                  >
                    Notification Settings
                  </Link>
                </div>
              </div>
            </div>

            {/* Recent Activities */}
            <div className="col-xxl-8 col-xl-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Recent System Activities</h4>
                  <Link to="#" className="btn btn-primary btn-sm">
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <div className="activity-timeline">
                    <div className="d-flex align-items-start mb-3">
                      <div className="avatar avatar-sm bg-success-transparent me-3">
                        <i className="ti ti-user-plus"></i>
                      </div>
                      <div>
                        <h6>New student registered</h6>
                        <p className="text-muted">John Doe registered for Grade 10</p>
                        <small className="text-muted">2 minutes ago</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-3">
                      <div className="avatar avatar-sm bg-warning-transparent me-3">
                        <i className="ti ti-file-text"></i>
                      </div>
                      <div>
                        <h6>Document request submitted</h6>
                        <p className="text-muted">Transfer certificate requested by Jane Smith</p>
                        <small className="text-muted">15 minutes ago</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-3">
                      <div className="avatar avatar-sm bg-info-transparent me-3">
                        <i className="ti ti-calendar"></i>
                      </div>
                      <div>
                        <h6>Class schedule updated</h6>
                        <p className="text-muted">Math class moved to Room 205</p>
                        <small className="text-muted">1 hour ago</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="col-xxl-4 col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Quick Actions</h4>
                </div>
                <div className="card-body">
                  <div className="d-grid gap-2">
                    <Link to={routes.addStudent} className="btn btn-primary">
                      <i className="ti ti-user-plus me-2"></i>Add New Student
                    </Link>
                    <Link to={routes.addTeacher} className="btn btn-success">
                      <i className="ti ti-user-plus me-2"></i>Add New Teacher
                    </Link>
                    <Link to={routes.userManagement} className="btn btn-info">
                      <i className="ti ti-settings me-2"></i>Manage Users
                    </Link>
                    <Link to={routes.documentRequestsManagement} className="btn btn-warning">
                      <i className="ti ti-file-text me-2"></i>Review Documents
                    </Link>
                    <Link to={routes.adminSettings} className="btn btn-secondary">
                      <i className="ti ti-settings-2 me-2"></i>Admin Settings
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
